import * as React from 'react'
import classnames from 'classnames'
import './Button.scss'
import { IconType, Icon } from '../icon'

type Props = {
  className?: string
  redirectUrl?: string
  callback?: (e: React.MouseEvent) => void
  buttonType: 'primary' | 'secondary' | 'tertiary'
  buttonStyle?: 'rounded' | 'square'
  display?: 'inline' | 'block'
  emphasise?: boolean
  size?: 'default' | 'large'
  disableBoxShadow?: boolean
  type?: 'button' | 'submit' | 'reset' | undefined // TODO: find a better way to include all anchor and button options
  disabled?: boolean
  id?: string
  icon?: IconType
  dataAttributes?: Record<string, string>
  title?: string
}

class Button extends React.Component<React.PropsWithChildren<Props>> {
  static defaultProps = {
    className: '',
    buttonStyle: 'rounded',
    display: 'inline',
    emphasise: false,
    size: 'default',
    disableBoxShadow: false,
    type: 'button',
    disabled: false,
  }

  render() {
    const {
      children,
      buttonType,
      buttonStyle,
      className,
      redirectUrl,
      callback,
      display,
      emphasise,
      size,
      disableBoxShadow,
      type,
      disabled,
      id,
      icon,
      dataAttributes,
      title,
    } = this.props

    const Element = redirectUrl ? 'a' : 'button'
    const actionType = redirectUrl ? 'redirect' : 'callback'
    const outputType = redirectUrl ? undefined : type
    const classes = classnames(
      'button',
      `button--type-${buttonType}`,
      `button--action-${actionType}`,
      `button--style-${buttonStyle}`,
      `button--display-${display}`,
      `button--size-${size}`,
      className,
      {
        'button--emphasise': emphasise,
        'button--no-box-shadow': disableBoxShadow || disabled,
        'button--disabled': disabled,
        'button--has-icon': icon,
      }
    )

    return (
      <Element
        {...dataAttributes}
        onClick={callback}
        href={redirectUrl}
        className={classes}
        type={outputType}
        disabled={disabled}
        id={id}
        title={title}
      >
        {icon && (
          <Icon
            className='button__icon'
            icon={icon}
          />
        )}
        <span className='button__children'>{children}</span>
      </Element>
    )
  }
}

export { Button }
